import { render, staticRenderFns } from "./NewClientAssignment.vue?vue&type=template&id=4745d3bf"
import script from "./NewClientAssignment.vue?vue&type=script&lang=js"
export * from "./NewClientAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports